import Animation from 'features/Animation/ThankYou2'

export default () =>
  <div className="my-2 article-width">
    <Animation />
  </div>
